import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spende',
  templateUrl: './spende.component.html',
  styleUrls: ['./../app.component.css']
})
export class SpendeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
